import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { CalendarModule } from 'primeng/primeng';
import { DeclaracionesComponent } from './declaraciones.component';
import { DeclaracionesService } from "./declaraciones.service";
import { CurrencyMaskModule } from "ng2-currency-mask";

@NgModule({
    declarations: [DeclaracionesComponent],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        CalendarModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage,
        CurrencyMaskModule],
    providers: [DeclaracionesService]

})

export class DeclaracionesModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/declaraciones/delcaraciones.module.ts